module.exports = __webpack_public_path__ + "static/media/Georgi_Tosev.da5ad90a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Georgi_Tosev.jpg
// module id = 161
// module chunks = 0